import React from 'react';
import { CFormSelect } from '@coreui/react';

const CustomDropdown = ({ options, selected, onSelect }) => {
    return (
        <CFormSelect className="mb-3" value={selected} onChange={(e) => onSelect(e)}>
          {options.map((option, index) => (
            <option key={index} value={option}>
              {option}
            </option>
          ))}
        </CFormSelect>
      );
};

export default CustomDropdown;
